export default __webpack_public_path__ + "static/media/street_wear_card.579594b8.png";